import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
    fill?: string;
};

const IconProfilePencil: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    color = '#23262A',
    fill = 'white',
}) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M18.7825 5.3487C18.6835 4.95321 18.4819 4.59084 18.1981 4.2982C17.9142 4.00557 17.5581 3.79302 17.1658 3.68203C15.7325 3.33203 9.99917 3.33203 9.99917 3.33203C9.99917 3.33203 4.26584 3.33203 2.83251 3.71536C2.44021 3.82635 2.08416 4.0389 1.8003 4.33154C1.51644 4.62417 1.31483 4.98654 1.21584 5.38203C0.95352 6.83666 0.825204 8.31229 0.832508 9.79036C0.823157 11.2796 0.951481 12.7664 1.21584 14.232C1.32497 14.6152 1.5311 14.9638 1.81429 15.2441C2.09749 15.5244 2.44819 15.7269 2.83251 15.832C4.26584 16.2154 9.99917 16.2154 9.99917 16.2154C9.99917 16.2154 15.7325 16.2154 17.1658 15.832C17.5581 15.721 17.9142 15.5085 18.1981 15.2159C18.4819 14.9232 18.6835 14.5609 18.7825 14.1654C19.0428 12.7217 19.1711 11.2573 19.1658 9.79036C19.1752 8.30116 19.0469 6.81428 18.7825 5.3487Z"
                fill={color}
            />
            <path d="M8.125 12.5164L12.9167 9.79141L8.125 7.06641V12.5164Z" fill={fill} />
        </svg>
    );
};

export default IconProfilePencil;
